module.exports = __webpack_public_path__ + "img/tz04.f353048e.jpg";